import { Handle, type NodeProps, type Node } from "@xyflow/react";
import type { WorkflowNodeData } from "../../lib/workflow-graph";
import { handlePositions, type HandleDirection } from "./handles";
import LinkHandles from "./LinkHandles";
import styles from "./WorkflowNode.module.css";

const EMAIL_TYPE_IDS = new Set(["0-4", "0-7", "0-13"]);
const TASK_TYPE_IDS = new Set(["0-3"]);

function actionVariant(actionTypeId: string | undefined): string {
  if (!actionTypeId) return "";
  if (EMAIL_TYPE_IDS.has(actionTypeId)) return styles.email;
  if (TASK_TYPE_IDS.has(actionTypeId)) return styles.task;
  return "";
}

export default function ActionNode({ data }: NodeProps<Node>) {
  const d = data as unknown as WorkflowNodeData & {
    direction?: HandleDirection;
  };
  const { source, target } = handlePositions(d.direction);
  const variant = actionVariant(d.actionTypeId);
  return (
    <div className={`${styles.card} ${variant}`}>
      <Handle type="target" position={target} />
      <p className={styles.kind}>{d.type}</p>
      <p className={styles.label}>{d.label}</p>
      {d.subtitle && <p className={styles.subtitle}>{d.subtitle}</p>}
      <Handle type="source" position={source} />
      <LinkHandles />
    </div>
  );
}
